export enum ErrorCode {
    Forbidden = 403,
    RemoteFileTooLarge = 436,
    TotalAttachmentSizeExceeded = 437,
    DuplicateCaseNumber = 438,
    InvalidCaptcha = 510,
    CaptchaBrowserError = 513,
    TechnicalError = 500
}